<template>
    <div class="gradient-bl-to-bg-to-bl">
        <div id="exportable-content">
            <Hero title="Terms of Service" colour-index="2" :left="true" />

            <div class="px-3 sm:px-28 sm:mt-12 sm:pb-12">
                <h2>Introduction</h2>
                <p>
                    Please Read Carefully Before Using This Website: The following terms of service ("Terms of Service")
                    govern your use of the Unified.to website
                    and website application (the "Site") and the Unified.to web-based, application and workflow
                    integration
                    service accessed through the Site
                    ("Service"), both of which are operated by Unified API Inc. ("Unified.to" or "we"). By using the
                    Site
                    and/or the Service, you irrevocably agree
                    that such use is subject to these Terms of Service. If you do not agree to these Terms of Service,
                    you
                    may not use the Site or the Service. If
                    you are entering into these Terms of Service on behalf of an entity, you are binding such entity to
                    these Terms of Service, you represent that
                    you have the actual authority to bind such entity to these Terms of Service, and references to "you"
                    mean such entity. For purposes hereof, the
                    "Site" includes all subdomains and components of the Unified.to website, including without
                    limitation
                    the Unified.to web application.
                </p>

                <p>
                    Unified.to expressly reserves the right to modify the Terms of Service at any time in its sole
                    discretion by including such alteration and/or
                    modification in these Terms of Service, along with a notice of the effective date of such modified
                    Terms
                    of Service. If a revision meaningfully
                    reduces your rights, we will use reasonable efforts to notify you (by, for example, sending an email
                    to
                    the billing contact you designate in
                    your User Account (as defined below), through your User Account or in the Service itself). To the
                    extent
                    you have purchased a subscription to
                    the Service, the modified terms will be effective as to such subscription Service upon your next
                    subscription renewal. In this case, if you
                    object to the updated terms, as your exclusive remedy, you may choose not to renew, including
                    cancelling
                    any terms set to auto-renew. In all
                    other cases, any continued use by you of the Site or the Service after the posting of such modified
                    Terms of Service shall be deemed to indicate
                    your irrevocable agreement to such modified Terms of Service. Accordingly, if at any time you do not
                    agree to be subject to any modified Terms
                    of Service, you may no longer use the Site or Service.
                </p>

                <p></p>

                <h2>User Account Registration</h2>

                <p>
                    (a) Account Registration and Use License: In order to access and use all of the features of the
                    Service,
                    you are required to open an account
                    ("User Account") by registering with Unified.to. When you register for your User Account you must
                    provide true, accurate, current and complete
                    information ("Account Information"), and you agree to update the Account Information in order to
                    ensure
                    that it is current. Upon proper
                    registration and opening of a User Account, and subject to all of the terms and conditions of these
                    Terms of Service, Unified.to hereby grants
                    to you the personal, non-transferable right and license to use the Service, solely for your own
                    internal
                    business purposes, until such time as
                    either you or Unified.to elect to terminate such right in accordance with these Terms of Service.
                </p>

                <p>
                    (b) Eligibility: As an express condition of being permitted to open a User Account, you represent
                    and
                    warrant that you (i) have the legal
                    capacity (including, without limitation, being of sufficient age) to enter into contracts under the
                    law
                    of the jurisdiction in which you reside,
                    (ii) are not on a list of persons barred you from receiving services under U.S. laws or other
                    applicable
                    jurisdiction and (iii) are not a
                    resident of Cuba, Iran, North Korea, Sudan or Syria.
                </p>

                <h2>Site Content</h2>

                <p>
                    ‍(a) Unified.to Content: The information, materials (including, without limitation, HTML, text,
                    audio,
                    video, white papers, press releases, data
                    sheets, product descriptions, software and FAQs and other content) available on the Site and/or the
                    Service, excluding Third Party Content
                    (collectively, "Unified.to Content"), are the copyrighted works of Unified.to, and Unified.to
                    expressly
                    retains all right title and interest in
                    and to the Unified.to Content, including, without limitation, all intellectual property rights
                    therein
                    and thereto. Except as expressly
                    permitted in these Terms of Service, any use of the Unified.to Content may violate copyright and/or
                    other applicable laws.
                </p>

                <p>
                    (b) Third Party Content: In addition to Unified.to Content, the Site and/or the Service may contain
                    information and materials provided to
                    Unified.to by third parties (collectively, "Third Party Content"). Third Party Content is the
                    copyrighted work of its owner, who expressly
                    retains all right title and interest in and to the Third Party Content, including, without
                    limitation,
                    all intellectual property rights therein
                    and thereto. In addition to being subject to these Terms of Service, Third Party Content may also be
                    subject to different and/or additional
                    terms of use and/or privacy policies of such third parties. Please contact the appropriate third
                    party
                    for further information regarding any
                    such different and/or additional terms of use applicable to Third Party Content.
                </p>

                <p>
                    (c) Limited Site Content License: Unified.to grants you the limited, revocable, non-transferable,
                    non-exclusive right to use the Unified.to
                    Content and Third Party Content (collectively, "Site Content") by displaying the Site Content on
                    your
                    computer, and downloading and printing
                    pages from the Site containing Site Content, under the condition that (i) such activity is solely
                    for
                    your personal, education or other
                    noncommercial use, (ii) you do not modify or prepare derivative works from the Site Content, (iii)
                    you
                    do not obscure, alter or remove any
                    notice of copyright set forth on any Site pages or Site Content, (iv) you do not otherwise
                    reproduce,
                    re-distribute or publicly display any of
                    the Site Content and (v) you do not copy any Site Content to any other media or other storage
                    format. No
                    other use of the Site Content is
                    authorized. Except as specified above, nothing contained herein shall be construed as conferring by
                    implication, or otherwise any license or
                    right under any patent, trademark, copyright or any other intellectual property right of Unified.to
                    or
                    any third party. All Site Content is
                    provided for informational purposes only.
                </p>

                <p>
                    (d) Trademarks: Unified.to, the Unified.to Logo and all Unified.to product names are trademarks and
                    services marks of Unified.to (collectively
                    "Unified.to Trademarks"), and nothing in these Terms or the Service shall be construed as granting
                    any
                    license or right to use the Unified.to
                    Trademarks without Unified.to's prior written consent. All trademarks, service marks and logos
                    included
                    on the Site ("Marks") are the property
                    of Unified.to or third parties, and you may not use such Marks without the express, prior written
                    consent of Unified.to or the applicable third
                    party.
                </p>

                <p>
                    (e) Monitoring of Site Content and use of Service: Unified.to reserves the right, but does not
                    undertake
                    the obligation, to monitor use of the
                    Site and/or the Service, and to investigate and take appropriate legal action against any party that
                    uses the Site in violation of these Terms
                    of Service or applicable law. Unified.to reserves the right to accept, reject or modify any Site
                    Content
                    or User Content, but assumes no
                    liability based on its acceptance, rejection, modification or failure to modify any Site Content or
                    User
                    Content.
                </p>

                <p>
                    (f) Copyright Infringement: As a condition of your right to use the Site and the Service, you agree
                    to
                    respect the intellectual property rights
                    of others. Accordingly, you agree not to upload or post to the Site or the Service any copyrighted
                    materials, trademarks or other proprietary
                    information belonging to any third party without the prior written consent of the applicable third
                    party. You acknowledge that Unified.to will
                    terminate your access to the Site and/or the Service if you repeatedly infringe the copyright of
                    third
                    parties. If you believe that your
                    copyrighted work has been illegally uploaded or posted on the Site or the Service, you may send a
                    written notice to Unified.to
                    contact@useUnified.to, and Unified.to will respond pursuant to its Digital Millennium Copyright Act
                    ("DMCA") procedure. Unified.to's DMCA
                    procedure is in accordance with that suggested by DMCA, the text of which can be found at the U.S.
                    Copyright Office web site
                    http://www.copyright.gov/legislation/dmca.pdf. Unified.to reserves all rights to seek damages and
                    fees
                    associated with infringement and/or
                    fraud.
                </p>

                <h2>Your Use of the Site and Service</h2>

                <p>
                    (a) Account and Use of Service: You may use your User Account for the Service and/or Site only in
                    accordance with these Terms of Service and
                    only for lawful purposes. You are responsible for your own communications, including the upload,
                    transmission and posting of information, and
                    are responsible for the consequences of their posting on or through the Service or Site.
                </p>

                <p>
                    (b) Fees: Some features of the Service may only be accessed and used upon the payment of applicable
                    fees
                    ("Fees"). Fees may vary depending on
                    usage in accordance with our current pricing policy. NOTWITHSTANDING ANYTHING CONTAINED HEREIN, ANY
                    SERVICE PROVIDED DURING THE FREE TRIAL
                    PERIOD IS PROVIDED "AS-IS" WITHOUT ANY REPRESENTATIONS, WARRANTIES OR INDEMNITIES. All Fees are
                    exclusive of all taxes, levies, or duties
                    imposed by taxing authorities, and you shall be responsible for payment of all such taxes, levies,
                    or
                    duties, excluding only United States
                    (federal or state) taxes.
                </p>

                <p>
                    (c) Refunds, Upgrading and Downgrading: Refunds are processed according to our fair refund policy.
                    Any
                    upgrade or downgrade in your Service use
                    will result in the new Fees being charged at the next billing cycle. There will be no prorating for
                    downgrades in between billing cycles.
                    Downgrading your Service may cause the loss of features or capacity of your User Account. Unified.to
                    does not accept any liability for such
                    loss.
                </p>

                <p>
                    (d) Cancellation and Termination by You: You are solely responsible for properly canceling your User
                    Account. An email or phone request to
                    cancel your User Account is not considered cancellation. You can cancel your User Account at any
                    time by
                    clicking on the settings link in the
                    global navigation bar at the top of the screen. The settings screen provides a simple
                    no-questions-asked
                    cancellation link. If you cancel your
                    User Account before the end of your current paid up month, your cancellation will take effect
                    immediately, and you will not be charged again.
                    Please note that we do not provide refunds for unused time in the last billing cycle.
                </p>

                <p>
                    (e) Termination and Suspension by Unified.to: Unified.to may terminate your User Account and/or
                    these
                    Terms of Service at any time and for any
                    reason upon notice to you. We may also suspend our Service to you at any time, with or without
                    cause. If
                    we terminate your User Account without
                    cause, we will refund a prorated portion of your monthly prepayment. We will not refund or reimburse
                    you
                    if we terminate your User Account for
                    cause, including (without limitation) for a violation of these Terms of Service.
                </p>

                <p>
                    (f) Effect of Termination: Once your User Account is terminated, we may permanently delete your User
                    Account and any or all User Content
                    associated with it. If you do not log in to your User Account for 12 or more months, we may treat
                    your
                    User Account as "inactive" and
                    permanently delete the User Account and all the data associated with it. Except where an exclusive
                    remedy may be specified in this Agreement,
                    the exercise by either party of any remedy, including termination, will be without prejudice to any
                    other remedies it may have under these Terms
                    of Service. All sections of this Agreement which by their nature should survive termination will
                    survive, including without limitation, accrued
                    rights to payment, use restrictions and indemnity obligations, confidentiality obligations, warranty
                    disclaimers, and limitations of liability.
                </p>

                <p>
                    (g) Prohibited Conduct: You agree not to use the Site or the Service for: (i) posting any (1)
                    information which is incomplete, false, inaccurate
                    or not your own, (2) trade secrets or material that is copyrighted or otherwise owned by a third
                    party
                    unless you have a valid license from the
                    owner which permits you to post it, (3) material that infringes on any other intellectual property,
                    privacy or publicity right of another, (4)
                    advertisement, promotional materials or solicitation related to any product or service that is
                    competitive with Unified.to products or services
                    or (5) software or programs which contain any harmful code, including, but not limited to, viruses,
                    worms, time bombs or Trojan horses; (ii)
                    impersonating another person; (iii) engaging in or encouraging conduct that would constitute a
                    criminal
                    offense, give rise to civil liability or
                    otherwise violate any city, state, national or international law or regulation, or which fails to
                    comply
                    with accepted Internet protocol; or
                    (iv) transmitting or transferring (by any means) information or software derived from the Site or
                    the
                    Service to foreign countries or certain
                    foreign nations in violation of US export control laws. In addition, you agree not to violate or
                    attempt
                    to violate the security of the Site,
                    the Service or Unified.to's system or network security, including, without limitation, the
                    following:
                    (w) accessing data not intended for users
                    of the Site or the Service, or gaining unauthorized access to an account, server or any other
                    computer
                    system; (x) attempting to probe, scan or
                    test the vulnerability of a system or network or to breach security or authentication measures; (y)
                    attempting to interfere with the function of
                    the Site, the Service, host or network, including, without limitation, via means of submitting a
                    virus
                    to the Site, overloading, "flooding",
                    "mailbombing", "crashing", or sending unsolicited e-mail, including promotions and/or advertising of
                    products or services; or (z) forging any
                    TCP/IP packet header or any part of the header information in any e-mail or newsgroup posting or
                    transmitting, importing, uploading, or
                    incorporating any financial or medical information of any nature, or any sensitive personal
                    information
                    (e.g., Social Security numbers, driver's
                    license numbers, birth dates, personal bank account numbers, passport or visa numbers, credit card
                    numbers, passwords and security credentials).
                    Violations of the Site's, the Service's or Unified.to's system or network security may result in
                    civil
                    or criminal liability.
                </p>

                <p>
                    In addition, you agree not to, directly or indirectly: (A) reverse engineer, decompile, disassemble
                    or
                    otherwise attempt to discover the source
                    code, object code or underlying structure, ideas or algorithms of the Service or any software,
                    documentation or data related to or provided with
                    the Service ("Software"); (B) modify, translate, or create derivative works based on the Service or
                    Software; or copy (except for archival
                    purposes), rent, lease, distribute, pledge, assign, or otherwise transfer or encumber rights to the
                    Service or Software; (C) use or access the
                    Service to build or support, and/or assist a third party in building or supporting, products or
                    services
                    competitive to Unified.to; (D) remove
                    any proprietary notices or labels from the Service or Software; or (E) otherwise use the Service or
                    Software outside of the scope of the rights
                    expressly granted herein. You agree to use the Service and Software only for your own internal
                    business
                    operations, and not to transfer,
                    distribute, sell, republish, resell, lease, sublease, license, sub-license or assign the Service or
                    use
                    the Service for the operation of a
                    service bureau or timesharing service.
                </p>

                <p>
                    (h) Your Data: You will retain ownership of any data, information or material originated by you that
                    you
                    transmit through the Service ("User
                    Content") - for example, User Content from your accounts with third party services (e.g., Gmail or
                    Dropbox) that passes through the Service. You
                    shall be solely responsible for the accuracy, quality, content and legality of User Content, the
                    means
                    by which User Content is acquired and the
                    transmission of User Content outside of the Service. You represent and warrant that you have all
                    rights
                    necessary to transmit User Content
                    through the Service and to otherwise have User Content used as part of the Service or as otherwise
                    contemplated herein.
                </p>

                <p>
                    (i) Your Posts: The Site and Service include functionality that permits users to post content,
                    images,
                    audio files, text, logos, sample code or
                    other materials or works in a manner that is intended to be viewed by other users ("Your Posts"),
                    including for reviews and in forums (e.g., in
                    the Unified.to Community). By submitting Your Posts to the Site and/or Service, you hereby grant to
                    Unified.to a perpetual, irrevocable,
                    royalty-free, worldwide, non-exclusive right and license, including the right to grant sublicenses
                    to
                    third parties, to use, reproduce, publicly
                    display, publicly perform, prepare derivative works from and distribute Your Posts for any purpose.
                    Unified.to may exercise all copyright,
                    publicity and moral rights, in any media, with respect to Your Posts. In addition, you hereby
                    irrevocably represent and warrant to Unified.to
                    that (i) you have all necessary power, authority, right, title and/or licenses to grant to
                    Unified.to
                    the foregoing right and license and (ii)
                    the posting, submission and display by you of Your Posts on the Site or Service, and the exercise by
                    Unified.to of the foregoing license does
                    not and will not (1) violate any applicable law or government regulation or (2) infringe any right
                    of
                    publicity or invades the privacy of
                    others, or any intellectual property right of any third party, (iii) none of Your Posts (1) will
                    constitute obscene, pornographic, indecent,
                    profane or otherwise objectionable material, (2) are discriminatory, hateful or bigoted toward, or
                    abusive of, any group or individual, or (3)
                    are libelous or defamatory.
                </p>

                <p>
                    (j) Suggestions: You hereby grant to Unified.to a royalty-free, worldwide, transferable,
                    sublicenseable,
                    irrevocable, perpetual license to use
                    or incorporate into the Site, the Service and/or other Unified.to offerings any suggestions,
                    enhancement
                    requests, recommendations or other
                    feedback provided by you to Unified.to that is related to the Site and/or the Service.
                </p>

                <p>
                    (k) Aggregated and/or Anonymized Data: Notwithstanding anything to the contrary set forth herein or
                    otherwise, except in the case of an On
                    Premise License (as defined below), Unified.to will have the right to collect and analyze data and
                    other
                    information relating to the provision,
                    use or performance of the Site and/or Service and related systems and technologies (including
                    information concerning User Content and data
                    derived therefrom), and to aggregate and/or anonymize all such data and information. Unified.to will
                    be
                    free at any time to: (i) use such
                    information and data to improve and enhance Unified.to's offerings; and (ii) disclose such data in
                    aggregate or other de-identified form in
                    connection with its business. If you access the Service through a license granted by Unified.to that
                    permits the local hosting of the Service on
                    hardware you maintain (an "On Premise License"), no User Content will be shared with Unified.to
                    through
                    your use of the Site or the Service with
                    the sole exception of anonymized data for the purposes of (i) confirming that each person accessing
                    the
                    Site or Service has a valid license to
                    do so and (ii) collecting anonymous aggregate non-personally identifiable usage analytics to
                    Unified.to's US-hosted servers (including but not
                    limited to task usage count, integrations used, etc.).
                </p>

                <p>
                    (l) Your Indemnification Obligations: You hereby irrevocably agree to indemnify, defend and hold
                    Unified.to, its affiliates, directors,
                    officers, employees and agents harmless from and against any and all loss, costs, damages,
                    liabilities
                    and expenses (including attorneys' fees)
                    arising out of or related to (i) any third party claim resulting from a breach by you of any of your
                    covenants, representations or warranties
                    contained in these Terms of Use and/or (ii) your use of the Site and/or the Service.
                </p>

                <p>
                    (m) Unified.to's Indemnification Obligations: If you are a paying subscriber to the Service,
                    Unified.to
                    will defend you against any third party
                    claim brought against you alleging that the use of such paid Service as permitted hereunder
                    infringes
                    the United States intellectual property
                    rights of a third party, and Unified.to shall pay all costs and damages finally awarded against you
                    by a
                    court of competent jurisdiction as a
                    result of any such claim; provided that you (a) promptly give written notice thereof to Unified.to;
                    (b)
                    give Unified.to sole control of the
                    defense and settlement of the claim; and (c) provide to Unified.to all reasonable assistance. The
                    foregoing shall not apply to any claim based
                    upon or arising from (i) any use of the Service outside the scope of these Terms of Service, (ii)
                    User
                    Content, or (iii) a combination of the
                    Service with any content or other technology not provided by Unified.to.
                </p>

                <p>
                    (n) Team Accounts: You may be invited to establish or join a Unified.to team account ("Team
                    Account").
                    Each Team Account will have an
                    administrator who can accept or remove Team Account members. By agreeing to join a Team Account, you
                    acknowledge that (i) your identity,
                    including name, email address, and avatar (if any), will be disclosed to other Team Account members,
                    and
                    the Team Account administrator will
                    also have access to your task usage, and (ii) your User Content will be viewable by all Team Account
                    members. You will have the option to share
                    with other Team Account members any integrations you have created and/or any third party
                    applications
                    with which you have connected. If you
                    share an integration, all Team Account members can view and edit such integration. If you share a
                    third
                    party application with which you have
                    connected, all Team Account members will have read/write access to the data associated with such
                    third
                    party application.
                </p>

                <p>
                    (o) Export Control: You hereby represent and warrant that (i) you understand and acknowledge that
                    some
                    Site Content or components of the Service
                    may be subject to export, re-export and import restrictions under applicable law, (ii) you will not
                    use
                    the Site, any Site Content or the
                    Service in a manner that violates the U.S. Export Administration Act of 1979 and the regulations of
                    the
                    U.S. Department of Commerce and (iii)
                    you are not located in, under the control of, or a national or resident of any country to which the
                    United States has embargoed goods.
                </p>

                <h2>Linked Websites and Services</h2>

                <p>
                    The Site and/or Service may contain links to and integrations with third party websites and services
                    (e.g., Hubspot or GitHub), and you agree
                    that Unified.to provides links to and integrations with such websites and services solely as a
                    convenience and has no responsibility for the
                    content or availability of such websites or services, and that Unified.to does not endorse such
                    websites
                    or services (or any products or other
                    services associated therewith). Access to any other internet site linked to the Site and/or Service
                    is
                    at your own risk, and Unified.to is not
                    responsible for the accuracy or reliability of any information, data, opinions, advice or statements
                    made on these sites. Your use of such
                    websites and services will be subject to the terms applicable to each such website and service. You
                    may
                    not post a link that directs users to
                    any content or information that would constitute a violation of these Terms of Service.
                </p>

                <h2>LIMITATION OF LIABILITY</h2>

                <p>
                    (a) Warranty Disclaimer: THE SITE, SITE CONTENT AND SERVICE ARE PROVIDED STRICTLY ON AN "AS IS" AND
                    "AS
                    AVAILABLE" BASIS, AND Unified.to MAKES
                    NO WARRANTY THAT THE SITE, SERVICE OR SITE CONTENT ARE COMPLETE, SUITABLE FOR YOUR PURPOSE,
                    RELIABLE,
                    USEFUL OR ACCURATE, AND ON BEHALF OF
                    ITSELF AND ITS LICENSORS, Unified.to HEREBY EXPRESSLY DISCLAIMS ANY AND ALL IMPLIED, STATUTORY OR
                    OTHER
                    WARRANTIES WITH RESPECT TO THE SITE,
                    SITE CONTENT AND SERVICE, OR THE AVAILABILITY OF THE FOREGOING, INCLUDING, WITHOUT LIMITATION, THE
                    IMPLIED WARRANTIES OF MERCHANTABILITY,
                    FITNESS FOR A PARTICULAR PURPOSE, TITLE AND NONINFRINGEMENT. THE ENTIRE RISK AS TO RESULTS OBTAINED
                    THROUGH USE OF THE SITE, SERVICE AND/OR THE
                    SITE CONTENT RESTS WITH YOU. Unified.to AND ITS SUPPLIERS WILL NOT BE LIABLE OR RESPONSIBLE IN ANY
                    WAY
                    FOR ANY LOSSES OR DAMAGE OF ANY KIND
                    INCURRED AS A RESULT OF THE USE OF OR RELIANCE ON ANY MATERIAL CONTAINED ON THE SITE OR SERVICE.
                    Unified.to MAKES NO REPRESENTATION OR WARRANTY
                    THAT THE AVAILABILITY OF THE SITE AND OR THE SERVICE WILL BE UNINTERRUPTED, OR THAT THE SITE,
                    SERVICE
                    AND/OR THE SITE CONTENT WILL BE ERROR FREE
                    OR THAT ALL ERRORS WILL BE CORRECTED.
                </p>

                <p>
                    (b) Limitation of Liability: TO THE FULLEST EXTENT PERMITTED BY APPLICABLE LAW, YOU AGREE THAT
                    Unified.to SHALL NOT BE LIABLE TO YOU FOR ANY (A)
                    INDIRECT, INCIDENTAL, CONSEQUENTIAL, PUNITIVE, SPECIAL, EXEMPLARY OR STATUTORY DAMAGES (INCLUDING,
                    WITHOUT LIMITATION, LOSS OF BUSINESS, LOSS OR
                    PROFITS, LOSS OF REVENUE, LOSS OF DATA, LOSS OF GOODWILL OR FOR ANY COST OF COVER OR COST OF
                    PROCUREMENT
                    OF SUBSTITUTE GOODS OR SERVICES), EVEN
                    IF Unified.to HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES, AND REGARDLESS OF THE LEGAL
                    THEORY
                    UNDER WHICH DAMAGES ARE SOUGHT, WHETHER IN
                    BREACH OF CONTRACT OR IN TORT, INCLUDING NEGLIGENCE OR (B) AMOUNTS IN THE AGGREGATE THAT EXCEED THE
                    FEES
                    PAID BY YOU TO Unified.to HEREUNDER IN
                    THE SIX (6) MONTHS PRECEDING THE DATE THE CLAIM AROSE.
                </p>

                <h2>Privacy Policy</h2>

                <p>
                    You acknowledge that you have read, understand and agree to Unified.to's Privacy Policy located at
                    https://www.unified.to/privacy, which is
                    hereby incorporated into and made a part of these Terms of Service by this reference.
                </p>

                <h2>Location of the Site and your Use</h2>

                <p>
                    Unified.to generally operates or controls the operation of this Site and the Service from offices in
                    the
                    United States. If you are using an On
                    Premise License to access the Site or the Service, User Content will be stored on your own dedicated
                    server and you will be solely responsible
                    for maintaining the security and accuracy of such User Content. In addition, the Site and the
                    Service
                    may be mirrored, and other websites
                    operated or controlled by Unified.to may be located, at various locations in and outside of the
                    United
                    States. With the exception of On Premise
                    License users, Unified.to makes no representation or warranty that all of the features of this Site
                    or
                    Service will be available to you outside
                    of the United States, or that they are permitted to be accessed outside of the United States. If you
                    access the Site or the Service through an
                    On Premise License, and comply in all material respects with these Terms of Service, the Site and
                    the
                    Service will be accessible to you to the
                    extent they are not void or prohibited in your jurisdiction. Additionally, the Site may not be
                    helpful
                    or relevant to all international users.
                    You acknowledge that you are solely responsible for any decision by you to use this Site and/or the
                    Service from other locations, and that such
                    use may be subject to, and that you are responsible for, compliance with applicable local laws.
                </p>

                <h2>Notices</h2>

                <p>
                    Unified.to may give notice applicable to Unified.to's general Service customer base by means of a
                    general notice on the Service portal, and
                    notices specific to you by electronic mail to your e-mail address on record in your User Account.
                </p>

                <h2>General</h2>

                <p>
                    These Terms of Service constitute the entire agreement and understanding between the parties
                    concerning
                    the subject matter hereof,
                    notwithstanding any different or additional terms that may be contained in the form of purchase
                    order or
                    other document used by you to place
                    orders or otherwise effect transactions hereunder, which such terms are hereby rejected. Neither
                    party
                    may assign these Terms of Service without
                    the prior written approval of the other, such approval not to be unreasonably withheld or delayed,
                    provided that such approval shall not be
                    required in connection with an assignment to an affiliate or to a successor to substantially all of
                    such
                    party's assets or business related to
                    these Terms of Service. These Terms of Service supersede all prior or contemporaneous discussions,
                    proposals and agreements between you and
                    Unified.to relating to the subject matter hereof. No amendment, modification or waiver of any
                    provision
                    of these Terms of Service will be
                    effective unless in writing and signed by an authorized representative of both parties. If any
                    provision
                    of these Terms of Service is held to be
                    invalid or unenforceable, the remaining portions will remain in full force and effect and such
                    provision
                    will be enforced to the maximum extent
                    possible so as to effect the intent of the parties and will be reformed to the extent necessary to
                    make
                    such provision valid and enforceable. During the term of these Terms of Service and for twelve (12)
                    months thereafter, you shall not, directly or indirectly, solicit for employment, hire or otherwise
                    engage any employee with whom you have had contact or became aware through your use of the Site or
                    the
                    Service, without Unified's prior written consent. A general public recruiting advertisement that is
                    not directed specifically at such persons shall not, by itself, constitute a breach of this section.
                    No waiver of rights by either party may be implied from any actions or failures to enforce rights
                    under
                    these Terms of Service. These Terms of
                    Service are intended to be and are solely for the benefit of Unified.to and you and do not create
                    any
                    right in favor of any third party. These
                    Terms of Service will be governed by and construed in accordance with the laws of the Province of
                    Ontario, without reference to its conflict of
                    laws principles. The Uniform Computer Information Transactions Act will not apply to this Agreement.
                    All
                    disputes arising out of or relating to
                    these Terms of Service will be submitted to the exclusive jurisdiction of a court of competent
                    jurisdiction located in Ontario, Canada, and each
                    party irrevocably consents to such personal jurisdiction and waives all objections to this venue.
                </p>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { setTitle } from '~~/services/common';

setTitle(
    'Terms of Use',
    'Terms of Use for the Unified.to website, products, and services.'
);
</script>

<style scoped>
h2 {
    font-size: 150%;
    font-weight: bold;
    margin-bottom: 20px;
    margin-top: 20px;
}

p {
    margin-bottom: 10px;
    color: var(--medium-gray);

}

ul {
    padding-left: 40px;
    margin-top: 20px;
    list-style: disc;
    color: var(--medium-gray);

}

ul li {
    margin-bottom: 10px;
}

a {
    text-decoration: underline;
}
</style>